<template>
  <tender-form-label :key="index" :label="options.Name" :prop="options.Key" :rules="rules">
    <span :class="['span-areacode', options.Disabled ? 'Disabled' : '']" @click="showDlgArea">{{ form[options.Key] }}</span>
    <el-dialog
      title="默认交易场所是备案地区所在的交易中心，如特殊情况请重新选择。"
      top="50px"
      custom-class="trading-center-dialog"
      v-model="dialogVisible"
      :show-close="true"
      :close-on-click-modal="false"
      append-to-body>
      <el-radio-group v-model="areaRadio">
        <el-radio v-for="item in optionsShen" :label="item.Name" :key="item.Value">{{ item.Name }}</el-radio>
      </el-radio-group>
      <el-radio-group v-model="areaRadio">
        <el-radio v-for="item in optionsShi" :label="item.Name" :key="item.Value">{{ item.Name }}</el-radio>
      </el-radio-group>
      <el-radio-group v-model="areaRadio">
        <el-radio v-for="item in optionsOther" :label="item.Name" :key="item.Value">{{ item.Name }}</el-radio>
      </el-radio-group>
      <template #footer>
        <div class="dialog-footer dac-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="enSure">确 定</el-button>
        </div>
      </template>
    </el-dialog>
  </tender-form-label>
</template>
<script>
import { tenderProjectConfig } from "@store/tender/modules/waterStore";
import { mapActions } from "vuex";
import { mixForFormItem } from "../../../js/mixins";
import api from "@/common/js/api";
import utils from "../../../js/utils";
export default {
  name: "FormInputTradingCenter",
  mixins: [mixForFormItem],

  data() {
    return {
      dialogVisible: false,

      areaRadio: "",
      options1: [],
      optionsShen: [],
      optionsShi: [],
      optionsOther: [],
      dialogVisible: false,
      countyLevelCity: {
        福清市: "福清市",
        长乐市: "长乐市",
        石狮市: "石狮市",
        晋江市: "晋江市",
        福安市: "福安市",
      },
    };
  },
  computed: {
    areaRadioId() {
      if (this.form.regionId.indexOf("x") !== -1) {
        return this.form.regionId;
      } else {
        let result = "";
        for (let i = 0; i < this.options1.length; i++) {
          if (this.options1[i].Name === this.areaRadio) {
            result = this.options1[i].Value;
          }
        }
        return result;
      }
    },
  },
  created() {
    this.setDefaultValue();

    this.setRegion(); //设置地区是否可用电子保函
    this.setTrandCenter();
  },
  methods: {
    setDefaultValue() {
      let { form = {}, options = {} } = this;
      utils
        .readyToSetFormItemDefault(form, options)
        .then(() => {
          this.setFormItemValue(options.Value || "");
        })
        .catch(() => null);
    },
    inputChangeHandle() {
      this.doValidate();
    },
    showDlgArea() {
      let { form = {}, options = {} } = this;
      if (options.Disabled) return false;
      this.dialogVisible = true;
    },
    setRegion() {
      let regionCode = this.form.TRADE_CENTER ? this.form.TRADE_CENTER.Value : this.form.regionId;
      api
        .get("/GuaranteePlugin/RegionCode", {
          code: regionCode,
        })
        .then((res) => {
          if (res.result) {
            this.form.IS_ABLE_USE_DZBH = true;
          } else {
            this.form.IS_ABLE_USE_DZBH = false;
          }
        });
    },
    setTrandCenter() {
      api.get("/region/list").then((res) => {
        if (res.result) {
          this.options1 = res.json;
          let options = res.json;
          for (let i = 0; i < options.length; i++) {
            let nameLast = options[i].Name.charAt(options[i].Name.length - 1);
            if (nameLast == "省") {
              this.optionsShen.push(options[i]);
            } else if (nameLast == "市" || options[i].Name === "平潭综合实验区") {
              if (this.countyLevelCity[options[i].Name]) {
                this.optionsOther.unshift(options[i]);
              } else {
                this.optionsShi.push(options[i]);
              }
            } else {
              this.optionsOther.push(options[i]);
            }
          }
          if (this.form.TRADE_CENTER_SELECT) {
            if (this.form.regionId.includes("3502")) {
              this.areaRadio = "厦门市";
            } else {
              this.areaRadio = this.form.TRADE_CENTER_SELECT;
            }
            this.enSure();
          }
          if (this.form.regionId && this.form.regionId.indexOf("x") !== -1) {
            this.disabled = true;
          }
        }
      });
    },
    enSure() {
      this.dialogVisible = false;
      if (!(tenderProjectConfig.BZJ_ADDRESS.indexOf(this.areaRadio) < 0)) {
        this.form.isBondOnline = true;
        this.form.isHasBond = true; //是否有保证金银行
      } else {
        this.form.isBondOnline = false;
        this.form.isHasBond = false;
        this.form.BOND_BANKS_SELECT = [];
      }
      if (this.form.TRADE_CENTER_SELECT !== this.areaRadio) {
        this.form.MARGIN_BANK = "";
        this.form.MARGIN_NAME = "";
        this.form.MARGIN_NUMBER = "";
        this.form.BOND_BANKS = [];
        this.form.BOND_BANKS_SELECT = [];
      }
      this.form.TRADE_CENTER_SELECT = this.areaRadio;
      // console.log(this.areaRadioId)
      this.setRegion();
      for (let i = 0; i < this.options1.length; i++) {
        if (this.options1[i].Value === this.areaRadioId) {
          this.form.TRADE_CENTER = this.options1[i];
          // this.setBondBlanks()
          return true;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$valueColor: #2393e4;
.span-areacode {
  display: inline-block;
  padding: 5px 5px;
  width: auto;
  min-width: 100px;
  line-height: 1;
  text-align: left;
  vertical-align: bottom;
  text-indent: 0;
  word-break: break-all;
  outline: none;
  color: $valueColor;
  border-bottom: 1px solid black;
  cursor: pointer;
}
.Disabled {
  background: #eee;
}
.el-radio-group .el-radio {
  min-width: 204px;
  margin-bottom: 5px;
}
// .el-radio-group .el-radio:first-child {
//   margin-left: 15px;
// }
.el-radio-group {
  margin-bottom: 15px;
}
</style>
<style lang="scss">
.is-error {
  .span-areacode {
    border-bottom-color: red;
  }
}
.trading-center-dialog {
  min-width: 950px;
  max-width: 950px;
  .el-dialog__body {
    min-height: 500px;
    max-height: 600px;
    overflow: auto;
    .el-radio {
      margin-right: 20px;
    }
    .dac-footer {
      margin-top: 10px;
      text-align: right;
    }
  }
}
</style>